export default __webpack_public_path__ + "static/media/electric.95b8f205.svg";